import {
  Box,
  Tabs,
  Tab,
  TabList,
  Heading,
  HStack,
  Spacer,
} from '@chakra-ui/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Typography } from 'packages/common-frontend/components/Typography';
import { Counter } from '~/packages/common-frontend/components/Counter';
import { useDataMetadataContext } from '~/valleyBank/domains/page/hooks/DataMetadataContext';

const TABS = [
  {
    key: 'summary' as const,
    label: 'Summary',
    route: '/valley-bank/loan-accounts',
  },
  {
    key: 'underMarginReport' as const,
    label: 'Under Margin Report',
    route: '/valley-bank/loan-accounts/under-margin-report',
  },
];

export type LoanAccountDetailsTab = typeof TABS[number]['key'];

type LoanAccountsDetailsTabsProps = { selectedTab: LoanAccountDetailsTab };
export const LoanAccountsDetailsTabs = ({
  selectedTab,
}: LoanAccountsDetailsTabsProps) => {
  const navigate = useNavigate();
  const { portfolioStats } = useDataMetadataContext();
  return (
    <Tabs
      variant="line"
      index={TABS.findIndex(({ key }) => key === selectedTab)}
      colorScheme="blue"
      background="white"
    >
      <TabList>
        {TABS.map(({ key, label, route }) => (
          <Tab key={key} onClick={() => navigate(route)}>
            {key === 'underMarginReport' &&
            portfolioStats?.underMarginStatusCount ? (
              <HStack>
                <Typography trim>{label}</Typography>
                <Counter count={portfolioStats.underMarginStatusCount} />
              </HStack>
            ) : (
              label
            )}
          </Tab>
        ))}
      </TabList>
    </Tabs>
  );
};

type LoanAccountsOverviewTemplateProps = {
  selectedTab: LoanAccountDetailsTab;
  children: React.ReactNode;
  headerChildren?: React.ReactNode;
};
export const LoanAccountsOverviewTemplate = ({
  selectedTab,
  children,
  headerChildren = <></>,
}: LoanAccountsOverviewTemplateProps) => {
  return (
    <>
      <HStack height="min-content">
        <Heading as="h1" size="lg" mb="6px">
          Loan Accounts
        </Heading>
        <Spacer />

        {headerChildren}
      </HStack>
      <LoanAccountsDetailsTabs selectedTab={selectedTab} />
      <Box w="100%" mt="40px">
        {children}
      </Box>
    </>
  );
};
